import React from 'react';
import { AnimatedCounter } from './AnimatedCounter';
import { UsersIcon, StarIcon, HeartIcon, TrendingUpIcon } from 'lucide-react';
export function SocialProofBanner() {
  const stats = [{
    icon: <UsersIcon className="w-8 h-8" data-id="element-328" />,
    value: 1247,
    suffix: '+',
    label: 'Mujeres Transformadas'
  }, {
    icon: <StarIcon className="w-8 h-8" data-id="element-329" />,
    value: 4.9,
    suffix: '/5',
    label: 'Rating Promedio'
  }, {
    icon: <HeartIcon className="w-8 h-8" data-id="element-330" />,
    value: 98,
    suffix: '%',
    label: 'Satisfacción'
  }, {
    icon: <TrendingUpIcon className="w-8 h-8" data-id="element-331" />,
    value: 30,
    suffix: ' días',
    label: 'Para Ver Resultados'
  }];
  return <section className="w-full py-16 bg-gradient-to-r from-magenta-600 to-pink-600 text-white" data-id="element-332">
      <div className="max-w-7xl mx-auto px-6" data-id="element-333">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-334">
          {stats.map((stat, index) => <div key={index} className="text-center space-y-3" data-id="element-335">
              <div className="flex justify-center text-gold-400" data-id="element-336">
                {stat.icon}
              </div>
              <div className="text-4xl lg:text-5xl font-bold" data-id="element-337">
                <AnimatedCounter end={stat.value} suffix={stat.suffix} data-id="element-338" />
              </div>
              <p className="text-sm lg:text-base text-gray-100" data-id="element-339">{stat.label}</p>
            </div>)}
        </div>
      </div>
    </section>;
}